<script lang="ts">
import { defineComponent, ref } from 'vue';
import { AuthStore } from 'stores/User/Auth.ts';

export default defineComponent({
  name: 'Navigation',

  setup() {
    const authStore = AuthStore();

    return {
      authStore,
      logoutLoading: ref(false),
      profileNav: [
        {
          label: 'Siparişlerim',
          icon: 'shopping_basket',
          link: '/user/orders',
          name: 'orders',
        },
        {
          label: 'İptal & İade',
          icon: 'real_estate_agent',
          link: '/user/cancellation-or-refund',
          name: 'cancellation-or-refund',
        },
        {
          label: 'Favorilerim',
          icon: 'favorite',
          link: '/user/favourites',
          name: 'favourites',
        },
        {
          label: 'Destek Taleplerim',
          icon: 'support_agent',
          link: '/user/support',
          name: 'support',
        },
        {
          label: 'Kullanıcı Bilgilerim',
          icon: 'account_circle',
          link: '/user/membership-info',
          name: 'membership-info',
        },
        {
          label: 'Adreslerim',
          icon: 'contacts',
          link: '/user/contacts',
          name: 'addresses',
        },
        {
          label: 'Şifre Güncelleme',
          icon: 'https',
          link: '/user/user-password',
          name: 'user-password',
        },
      ],
    };
  },

  methods: {
    isActive(routeName: string) {
      return this.$route.name === routeName;
    },

    logout() {
      this.logoutLoading = true;
      this.authStore.logout().then(() => {
        this.$q.notify({
          color: 'green',
          textColor: 'white',
          icon: 'check',
          message: 'Başarıyla çıkış yaptınız',
          position: 'bottom',
          timeout: Math.random() * 5000 + 3000,
        });
        window.location.replace('/');
        setTimeout(() => {
          this.logoutLoading = false;
        }, 1000);
      });
    },
  },
});
</script>

<template>
  <section id="userSection">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 q-px-md">
          <q-card class="shadow-0 bg-transparent">
            <div class="flex justify-between items-center q-mb-md">
              <div>
                <q-avatar color="primary" class="text-white">
                  <q-icon name="apps" size="sm" />
                </q-avatar>
                <q-chip color="primary" class="text-subtitle1 text-weight-bold text-white">Kullanıcı Profili</q-chip>
              </div>
              <div>
                <q-btn flat dense class="text-weight-medium q-px-sm" rounded @click="logout">
                  <q-icon name="power_settings_new" size="1.2rem" left />
                  Çıkış yap
                </q-btn>
              </div>
            </div>
            <q-list>
              <q-item
                :key="key"
                v-for="(nav, key) in profileNav"
                :to="`${nav.link}`"
                class="navigation-link--item q-py-sm q-mb-xs q-pl-sm"
                :class="isActive(nav.name) ? 'bg-accent text-primary' : 'bg-white'"
                clickable
                v-ripple
              >
                <q-item-section avatar class="q-mr-sm">
                  <q-btn :color="isActive(nav.name) ? 'primary' : 'accent'" class="q-py-md" size="sm" unelevated>
                    <q-icon :name="nav.icon" :color="isActive(nav.name) ? 'white' : 'primary'" size="1.4rem" />
                  </q-btn>
                </q-item-section>
                <q-item-section class="user-nav--item-text">{{ nav.label }}</q-item-section>
              </q-item>
            </q-list>
          </q-card>
        </div>
        <div class="col-12 col-lg-8 q-px-md">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
#userSection {
  font-family: 'EB Garamond', serif;
  letter-spacing: 0.06rem;
  font-size: 1rem;
  font-weight: 500;
  color: var(--q-primary);
}

#userSection .user-nav--item-text {
  font-weight: 900;
}

.navigation-link--item {
  border-radius: 5px;
}
</style>
